import { j as r } from "../../../../jsx-runtime-B6kdoens.js";
import { a as x } from "../../../../index-CROKJrb5.js";
import { c as f, f as p } from "../../../../create-component-CBAeEoQ6.js";
import { CardTitle as d } from "../../CardTitle/index.js";
import { MediaCardMeta as j } from "../MediaCardMeta/index.js";
const w = f(
  "MediaCardContent",
  p(
    ({
      as: o,
      children: l,
      className: a,
      image: e = null,
      label: u = null,
      meta: c = null,
      tags: n = null,
      title: s = null,
      ...m
    }, i) => {
      const t = o || "div";
      return /* @__PURE__ */ r.jsxs(
        t,
        {
          className: x("cur-flex cur-grow cur-flex-col cur-gap-2", a),
          ref: i,
          ...m,
          children: [
            /* @__PURE__ */ r.jsxs("div", { className: "cur-flex cur-grow cur-flex-col cur-items-start cur-gap-2", children: [
              e,
              u || s || l || c ? /* @__PURE__ */ r.jsxs("div", { className: "cur-flex cur-grow cur-flex-col cur-gap-2 cur-px-1", children: [
                u ? /* @__PURE__ */ r.jsx("div", { className: "cur-mb-2 cur-flex cur-flex-wrap", children: u }) : null,
                typeof s == "string" ? /* @__PURE__ */ r.jsx(d, { children: s }) : s,
                l ? /* @__PURE__ */ r.jsx("div", { className: "[&_p]:cur-mb-2 last:[&_p]:cur-mb-0", children: l }) : null,
                typeof c == "string" ? /* @__PURE__ */ r.jsx(j, { className: "cur-mb-4", children: c }) : c
              ] }) : null
            ] }),
            n
          ]
        }
      );
    }
  )
);
export {
  w as MediaCardContent
};
//# sourceMappingURL=index.js.map
